// extracted by mini-css-extract-plugin
module.exports = {"Root":"Logo_Root__15Cnc"};